import React, { useState } from "react";
import { toast } from "sonner";
import { finApi, finErr } from "@/lib/financeApi";
import { btn, btnGreen, btnRed } from "@/components/nds/windows/finance/parts";
import { InlineAction } from "@/components/nds/windows/finance/recordParts";
import { useIsSuper } from "@/components/nds/windows/finance/InvoiceActions";

/** SA: Approve (draft) · Mark paid (approved) · Void (any non-voided, note required). */
export default function PayoutActions({ p, onChanged }) {
  const isSuper = useIsSuper();
  const [voiding, setVoiding] = useState(false);
  const [busy, setBusy] = useState(false);
  const act = async (path, body, msg) => {
    setBusy(true);
    try { await finApi.patch(`/session-payouts/${p.id}/${path}`, body); toast.success(msg); setVoiding(false); onChanged(); }
    catch (e) { toast.error(finErr(e)); } finally { setBusy(false); }
  };
  if (!isSuper || p.status === "voided") return null;
  if (voiding) return <InlineAction id={`fin-payout-${p.id}`} mode="void" placeholder="Void reason (required)" confirmClass={btnRed} busy={busy}
    onConfirm={(note) => act("void", { note }, "Payout voided")} onCancel={() => setVoiding(false)} />;
  const stop = (fn) => (e) => { e.stopPropagation(); fn(); };
  return (
    <div className="flex flex-wrap gap-2">
      {p.status === "draft" && <button type="button" disabled={busy} onClick={stop(() => act("approve", {}, "Payout approved"))} data-testid={`fin-payout-approve-${p.id}`} className={`${btn} border-sky-400/40 text-sky-300 hover:bg-sky-500/10`}>Approve</button>}
      {p.status === "approved" && <button type="button" disabled={busy} onClick={stop(() => act("pay", {}, "Paid · disbursement posted"))} data-testid={`fin-payout-pay-${p.id}`} className={btnGreen}>Mark paid</button>}
      <button type="button" onClick={stop(() => setVoiding(true))} data-testid={`fin-payout-void-${p.id}`} className={btnRed}>Void</button>
    </div>
  );
}
